// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import share01Icon from "@/assets/icons/share-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Share01IconProps = Omit<IconProps, "name">;

export function Share01Icon(props: Share01IconProps): React.ReactNode {
  return <Icon name={share01Icon} {...props} />;
}
